<template>
<div class="chapter">
<div class="inner_page">
<p class="p4"><i></i> </p>
<p class="p4"><i></i> </p>
<p class="p6"><i>The water says:</i><span class="Apple-converted-space"> </span></p>
<p class="p6"><i>I remember.</i><span class="Apple-converted-space"> </span></p>
<p class="p6"><i>I came first of all.</i><span class="Apple-converted-space"> </span></p>
<p class="p6"><i>There was nothing before me.</i><span class="Apple-converted-space"> </span></p>
<p class="p4"><i></i> </p>
<p class="p6"><i>In the time of rain</i><span class="Apple-converted-space"> </span></p>
<p class="p6"><i>rain fell on the water.</i><span class="Apple-converted-space"> </span></p>
<p class="p6"><i>In the time of dryness</i><span class="Apple-converted-space"> </span></p>
<p class="p6"><i>the water reflected the sky.</i><span class="Apple-converted-space"> </span></p>
<p class="p4"><i></i> </p>
<p class="p6"><i>I came first of all.</i><span class="Apple-converted-space"> </span></p>
<p class="p6"><i>There was nothing before me.</i><span class="Apple-converted-space"> </span></p>
<p class="p4"><i></i> </p>
<p class="p6"><i>Vapor rose.</i><span class="Apple-converted-space"> </span></p>
<p class="p6"><i>It became</i><span class="Apple-converted-space"> </span></p>
<p class="p6"><i>the tree of heaven.</i><span class="Apple-converted-space"> </span></p>
<p class="p4"><i></i> </p>
<p class="p6"><i>Vapor rose.</i><span class="Apple-converted-space"> </span></p>
<p class="p6"><i>It became</i><span class="Apple-converted-space"> </span></p>
<p class="p6"><i>the bird of the sun.</i><span class="Apple-converted-space"> </span></p>
<p class="p4"><i></i> </p>
<p class="p6"><i>A seed fell.</i><span class="Apple-converted-space"> </span></p>
<p class="p6"><i>The earth began growing.</i><span class="Apple-converted-space"> </span></p>
<p class="p6"><i>Animals sprang up.</i><span class="Apple-converted-space"> </span></p>
<p class="p6"><i>The vegetation was thick.</i><span class="Apple-converted-space"> </span></p>
<p class="p4"><i></i> </p>
<p class="p6"><i>Then came the people.</i><span class="Apple-converted-space"> </span></p>
<p class="p6"><i>Then came the spirits</i><span class="Apple-converted-space"> </span></p>
<p class="p6"><i>and the powerful demons</i><span class="Apple-converted-space"> </span></p>
<p class="p6"><i>who live under the earth.</i><span class="Apple-converted-space"> </span></p>
<p class="p4"><i></i> </p>
<p class="p6"><i>Let me tell you:</i><span class="Apple-converted-space"> </span></p>
<p class="p6"><i>I will outlast them.</i><span class="Apple-converted-space"> </span></p>
<p class="p4"><i></i> </p>
<p class="p6"><i>Even the demons</i><span class="Apple-converted-space"> </span></p>
<p class="p6"><i>will disappear in time.</i><span class="Apple-converted-space"> </span></p>
<p class="p4"><i></i> </p>
<p class="p6"><i>I have no shape.</i><span class="Apple-converted-space"> </span></p>
<p class="p6"><i>No one can divide me.</i><span class="Apple-converted-space"> </span></p>
<p class="p6"><i>No one can say</i><span class="Apple-converted-space"> </span></p>
<p class="p6"><i>what I really am.</i></p>
<p class="p4"><b></b> </p>
<p class="p4"> </p>
<p class="p4"> </p>
<p class="p3"> </p>
<p class="p3"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section4.vue?39bc3044